/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState, useEffect, useRef } from "react";
import { calculateSizes } from "./utils";
import ArtworkAlert from "../ArtworkAlert.vue";
import { useDtfStore } from "../store";
import "./Height.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

function Height({ className, ...restProps }: any) {
  const [customHeight, setCustomHeight] = useState(null);
  const [showCustomSize, setShowCustomSize] = useState(false);
  const timerRef = useRef(null);

  const sizes = [
    {
      label: "4 Inches",
      value: 4
    },
    {
      label: "6 Inches",
      value: 6
    },
    {
      label: "8 Inches",
      value: 8
    },
    {
      label: "10 Inches",
      value: 10
    }
  ];

  const store = useDtfStore();

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  function isSelected(size: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return letterNumberArtwork().height === size.value && !showCustomSize;
  }

  function loadFromConfig() {
    // @ts-expect-error TS(4111): Property 'loadFromConfig' comes from an index sign... Remove this comment to see the full error message
    return store.loadFromConfig;
  }

  function dtfMinHeight() {
    // @ts-expect-error TS(4111): Property 'dtfMinHeight' comes from an index signat... Remove this comment to see the full error message
    return store.dtfMinHeight;
  }

  function dtfMaxHeight() {
    // @ts-expect-error TS(4111): Property 'dtfMaxHeight' comes from an index signat... Remove this comment to see the full error message
    return store.dtfMaxHeight;
  }

  function isValidCustomSize() {
    return (
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      Number(letterNumberArtwork().height) >= dtfMinHeight() &&
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      Number(letterNumberArtwork().height) <= dtfMaxHeight()
    );
  }

  function updateHeight(height: any) {
    const artworkSizes = calculateSizes({
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...letterNumberArtwork(),
      height
    });
    const isValid = isValidCustomSize();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      isValid,
      height,
      sizes: artworkSizes
    });
    if (isValid && Object.keys(artworkSizes).length) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.getArtworksPricing();
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateJerseyNumberPdpDates();
  }

  function handleSelect(size: any) {
    setShowCustomSize(false);
    setCustomHeight(null);
    const height = size.value;
    updateHeight(height);
  }

  function handleCustomSelect() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      isValid: false
    });
    setShowCustomSize(true);
  }

  function handleCustomInputChange(event: any, callback: any) {
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    clearTimeout(timerRef.current);
    const { value } = event.target;
    let inputValue = value.match(/(\d+(\.\d*)?)/);
    inputValue = inputValue ? inputValue[0] : "0";
    const splitHeight = inputValue.split(".");
    if (splitHeight[1] && splitHeight[1].length > 2) {
      inputValue = Number([splitHeight[0], splitHeight[1].slice(0, 2)].join("."));
    }
    event.target.value = inputValue;
    // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
    timerRef.current = setTimeout(() => {
      callback(inputValue);
    }, 1000);
  }

  // @ts-expect-error TS(2339): Property 'height' does not exist on type 'unknown'... Remove this comment to see the full error message
  const { height } = letterNumberArtwork();
  const prevHeightRef = useRef(height);

  useEffect(() => {
    if (prevHeightRef.current && height === null) {
      setCustomHeight(null);
      setShowCustomSize(false);
    }
    prevHeightRef.current = height;
  }, [height]);

  useEffect(() => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const presetHeight = sizes.find(size => size.value === letterNumberArtwork().height);
    if (!loadFromConfig() && !presetHeight) {
      setShowCustomSize(true);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      setCustomHeight(letterNumberArtwork().height);
    }
    const isValid = isValidCustomSize();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      isValid
    });
  }, []);

  useEffect(
    () => () => {
      // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      clearTimeout(timerRef.current);
    },
    []
  );

  return (
    <div {...restProps} className={cn("jersey-numbers-height", className)}>
      <div className="jersey-numbers-height__sizes">
        {renderList(sizes, size => (
          <div
            className={cn(
              "jersey-numbers-height__size",
              isSelected(size) && "jersey-numbers-height__size--selected"
            )}
            key={size.value}
            onClick={() => {
              handleSelect(size);
            }}
            data-testid="height-div"
          >
            {size.label}
          </div>
        ))}
        <div
          className={cn(
            "jersey-numbers-height__size",
            showCustomSize && "jersey-numbers-height__size--selected"
          )}
          onClick={() => {
            handleCustomSelect();
          }}
          data-testid="height-div-1"
        >
          {" "}
          Custom size{" "}
        </div>
      </div>
      {showCustomSize ? (
        <>
          <p className="jersey-numbers-height__label">Height (inches)</p>
          <input
            className="jersey-numbers-height__input"
            // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | nu... Remove this comment to see the full error message
            value={customHeight}
            onInput={e => {
              // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to parameter of type 'SetStateAction<null>'.
              setCustomHeight(e.target.value);
              handleCustomInputChange(e, updateHeight);
            }}
            // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
            maxLength="4"
            type="tel"
            data-testid="jersey-numbers-height-input"
          />
          {customHeight && !isValidCustomSize() ? (
            <ArtworkAlert
              className="jersey-numbers-height__error"
              data-testid="jersey-numbers-height-error"
            >
              {"Please enter a valid height between"}
              {dtfMinHeight()}
              {"and"}
              {dtfMaxHeight()}
              {"inches"}
            </ArtworkAlert>
          ) : null}
        </>
      ) : null}
    </div>
  );
}

export default Height;
